'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = connectField;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _createContextExtractor = require('./createContextExtractor');

var _createContextExtractor2 = _interopRequireDefault(_createContextExtractor);

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function connectField(fieldName) {
  var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var customValidations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return function (FieldComponent) {
    var _dec, _class;

    var Field = (_dec = (0, _reactRedux.connect)(function (state, _ref) {
      var onionFormName = _ref.onionFormName,
          name = _ref.name;
      return {
        field: state.onionForm.getIn(['fields', onionFormName, name || fieldName])
      };
    }, function (dispatch, _ref2) {
      var onionFormName = _ref2.onionFormName;
      return {
        actions: (0, _redux.bindActionCreators)((0, _actions2.default)(onionFormName), dispatch)
      };
    }), _dec(_class = function (_Component) {
      (0, _inherits3.default)(Field, _Component);

      function Field() {
        (0, _classCallCheck3.default)(this, Field);
        return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
      }

      Field.prototype.componentDidMount = function componentDidMount() {
        var _props = this.props,
            name = _props.name,
            onionFieldRegister = _props.onionFieldRegister;

        onionFieldRegister(name, this);
        this._setDefaultValue(this.props);
      };

      Field.prototype.componentWillReceiveProps = function componentWillReceiveProps(next) {
        var _props2 = this.props,
            name = _props2.name,
            onionFieldRegister = _props2.onionFieldRegister;

        if (name !== next.name) {
          onionFieldRegister(name, null);
          onionFieldRegister(next.name, this);
          this._setDefaultValue(next);
        }
      };

      Field.prototype.componentWillUnmount = function componentWillUnmount() {
        var _props3 = this.props,
            name = _props3.name,
            onionFieldRegister = _props3.onionFieldRegister;

        onionFieldRegister(name, null);
      };

      Field.prototype.onBlur = function onBlur() {
        var _props4 = this.props,
            name = _props4.name,
            liveValidation = _props4.field.liveValidation,
            onBlur = _props4.onBlur,
            setFieldLiveValidation = _props4.actions.setFieldLiveValidation,
            onionLiveValidate = _props4.onionLiveValidate;

        // if live validation is not already set, set it now

        var result = !liveValidation ? setFieldLiveValidation(name, true) : true;

        // call passed callback
        if (typeof onBlur === 'function') onBlur({ name: name });

        if (typeof onionLiveValidate === 'function') onionLiveValidate();

        return result;
      };

      Field.prototype.onFocus = function onFocus() {
        var _props5 = this.props,
            name = _props5.name,
            onFocus = _props5.onFocus;

        return onFocus && onFocus({ name: name });
      };

      Field.prototype.onChange = function onChange(_ref3) {
        var value = _ref3.value,
            target = _ref3.target;
        var _props6 = this.props,
            name = _props6.name,
            onChange = _props6.onChange,
            setFieldValue = _props6.actions.setFieldValue,
            onionLiveValidate = _props6.onionLiveValidate;

        // fix checkbox to return value based on checked/unchecked

        var newValue = typeof value === 'boolean' ? value : value || target && (target.type === 'checkbox' ? target.checked : target.value);

        var result = setFieldValue(name, newValue);

        // call passed callback
        if (typeof onChange === 'function') onChange({ name: name, value: newValue });

        if (typeof onionLiveValidate === 'function') onionLiveValidate();

        return result;
      };

      Field.prototype.getFieldProps = function getFieldProps() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var field = props.field;

        return field ? field.toJS() : {};
      };

      Field.prototype.validations = function validations() {
        return customValidations;
      };

      Field.prototype.msg = function msg(key) {
        var _props7 = this.props,
            onionFormName = _props7.onionFormName,
            msg = _props7.msg;


        if (!msg) return null;

        return msg(['form.' + onionFormName + '.' + key, 'form.' + key, '' + key]);
      };

      Field.prototype._resolveDefaultProps = function _resolveDefaultProps() {
        if (typeof defaultProps === 'function') return defaultProps(this.props) || {};

        return defaultProps;
      };

      Field.prototype._setDefaultValue = function _setDefaultValue(props) {
        var fieldProps = this.getFieldProps(props);

        // Enable to set default value only if value is undefined
        if (typeof fieldProps.value !== 'undefined') {
          return;
        }

        var defaultValueToSet = props.defaultValue || defaultProps.defaultValue || fieldProps.value;
        var setFieldValue = props.actions.setFieldValue;


        setFieldValue(props.name, defaultValueToSet);
      };

      Field.prototype.render = function render() {
        var _props8 = this.props,
            name = _props8.name,
            onionFormName = _props8.onionFormName,
            label = _props8.label,
            tooltip = _props8.tooltip,
            hint = _props8.hint,
            placeholder = _props8.placeholder,
            rest = (0, _objectWithoutProperties3.default)(_props8, ['name', 'onionFormName', 'label', 'tooltip', 'hint', 'placeholder']);

        var field = this.getFieldProps();
        var error = field.error || field.apiError;

        var defaultProps = this._resolveDefaultProps();
        var fieldProps = this.getFieldProps();

        return _react2.default.createElement(FieldComponent, (0, _extends3.default)({}, rest, defaultProps, fieldProps, {
          value: fieldProps.value || '',
          error: error && this.msg('errors.' + error, error) || error,
          hint: hint || defaultProps.hint || this.msg(name + '.hint'),
          label: label || defaultProps.label || this.msg(name + '.label'),
          placeholder: placeholder || defaultProps.placeholder || this.msg(name + '.placeholder'),
          name: name,
          onBlur: this.onBlur.bind(this),
          onChange: this.onChange.bind(this),
          onFocus: this.onFocus.bind(this),
          onionFormName: onionFormName,
          tooltip: tooltip || defaultProps.tooltip || this.msg(name + '.tooltip')
        }));
      };

      return Field;
    }(_react.Component)) || _class);
    Field.displayName = 'Form' + fieldName + 'Field';
    Field.propTypes = {
      actions: _propTypes2.default.object,
      dispatch: _propTypes2.default.func,
      defaultValue: _propTypes2.default.string,
      field: _propTypes2.default.object,
      hint: _propTypes2.default.string, // custom
      label: _propTypes2.default.string, // custom
      msg: _propTypes2.default.func, // custom -> given by translate() decorator #finance-translate
      name: _propTypes2.default.string,
      onBlur: _propTypes2.default.func, // custom
      onChange: _propTypes2.default.func, // custom
      onFocus: _propTypes2.default.func, // custom
      onionFieldRegister: _propTypes2.default.func.isRequired,
      onionFormName: _propTypes2.default.string.isRequired,
      onionLiveValidate: _propTypes2.default.func.isRequired,
      placeholder: _propTypes2.default.string, // custom
      tooltip: _propTypes2.default.string, // custom
      validations: _propTypes2.default.array
    };
    Field.defaultProps = {
      name: fieldName
    };


    return (0, _createContextExtractor2.default)(fieldName)(Field);
  };
}
module.exports = exports['default'];